import {
    PickersDay as MaterialPickersDay,
    type PickersDayProps,
} from '@mui/x-date-pickers';
import { Moment } from 'moment';

export const PickersDay = (props: PickersDayProps<Moment>) => {
    return (
        <MaterialPickersDay
            data-testid={'PickersDay-container'}
            {...props}
        />
    );
};

export default PickersDay;
